import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";
import CampaignsContent from "../../components/Pages/Campaigns";

const { displayName } = config;

export default function Campaigns() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${displayName}: ${t("routes.campaigns")}`;
  }, [t]);

  // No title prop on Layout: each screen renders its own heading, so a control
  // can sit beside it — the same arrangement Dashboard uses.
  return (
    <Layout>
      <CampaignsContent />
    </Layout>
  );
}
